"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentResourceAssertions = exports.ResourceConsumptionConditionsMet = exports.MandatoryResourcesConsumed = exports.ComponentResourceRequirement = void 0;
const enums_1 = require("../enums");
const COMPONENT_RESOURCE_REQUIREMENT_ID = 'req_cadstromcres000000000000000000000000';
exports.ComponentResourceRequirement = {
    id: COMPONENT_RESOURCE_REQUIREMENT_ID,
    slug: 'cadstrom.resource',
    slugPrefix: 'RESOURCE',
    name: 'Component Resource',
    description: 'Asserts that every resource a component’s package declares — an internal capability only one function may use at a time (a communication core, a configurable block) — is consumed as required: a resource marked mandatory is consumed by a used function, and a consumed resource’s conditions are met. Evaluated once per component resource.',
};
exports.MandatoryResourcesConsumed = {
    id: 'asrt_cresmustconsumed0000000000000000000',
    slug: 'cadstrom.resource.consumption.mandatory_consumed',
    requirementDefinitionId: COMPONENT_RESOURCE_REQUIREMENT_ID,
    name: 'A resource that must be consumed must be consumed by a function',
    description: 'A resource the package marks as mandatory must be consumed by a used function in the evaluated operating state. A mandatory resource left unconsumed means the component has no function driving that capability.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.ResourceConsumptionConditionsMet = {
    id: 'asrt_cresconditionsmet000000000000000000',
    slug: 'cadstrom.resource.consumption.conditions_met',
    requirementDefinitionId: COMPONENT_RESOURCE_REQUIREMENT_ID,
    name: 'A consumed resource’s conditions must be met',
    description: 'When a function consumes a resource, the conditions the resource declares (its required device modes) must hold in the evaluated operating state.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Draft,
};
exports.ComponentResourceAssertions = [
    exports.MandatoryResourcesConsumed,
    exports.ResourceConsumptionConditionsMet,
];
//# sourceMappingURL=component-resource.js.map